<template>
    <ul class="word">
        <li v-for="(list, index) in lists" :key="index" 
            :class="selected===list.id?'active':''"
            @click="$emit('changed', list)"
        >
            <span>{{lang[list.lang] || list.label}}</span>
        </li>
    </ul>
</template>

<script>
export default {

    name: '',
    props: ['lang', 'selected', 'lists']

}
</script>

<style lang="scss" scoped>
ul {
    li {
        padding: .4em .8em;
        background-color: #F4F4F4;
        span{
            color: #898989;
        }
        &.active{
            background-color: $color-point;
            span{
                color: #FFFFFF;
            }
        }
    }

    &.word {
        li {
            display: inline-block;
            margin-right: 4px;
            margin-bottom: 4px;
            border-radius: 16px;
        }
    }

}
</style>